import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import {
	PipedriveCompanyDealCreationTriggerResponse,
	PipedriveCompanySyncTriggerResponse,
	PipedriveConversationSyncResponse,
	PipedriveDealConfigResponse,
	PipedriveLeadConfigResponse,
	PipedriveOAuthStatusResponse,
} from "../../pages/Company/schema/pipedrive";

import { pipedriveApi } from "./pipedrive.api";

interface PipedriveState {
	oauthStatus: PipedriveOAuthStatusResponse | null;
	conversationSync: PipedriveConversationSyncResponse | null;
	companySyncTrigger: PipedriveCompanySyncTriggerResponse | null;
	dealCreationTrigger: PipedriveCompanyDealCreationTriggerResponse | null;
	dealConfig: PipedriveDealConfigResponse | null;
	leadConfig: PipedriveLeadConfigResponse | null;
}

const initialState: PipedriveState = {
	oauthStatus: null,
	conversationSync: null,
	companySyncTrigger: null,
	dealCreationTrigger: null,
	dealConfig: null,
	leadConfig: null,
};

export const pipedriveSlice = createSlice({
	name: "pipedrive",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			pipedriveApi.endpoints.getPipedriveOAuthStatus.matchFulfilled,
			(state, { payload }) => {
				state.oauthStatus = payload;
			}
		);
		builder.addMatcher(
			pipedriveApi.endpoints.getPipedriveConversationSync.matchFulfilled,
			(state, { payload }) => {
				state.conversationSync = payload;
			}
		);
		builder.addMatcher(
			pipedriveApi.endpoints.updatePipedriveConversationSync.matchFulfilled,
			(state, { payload }) => {
				state.conversationSync = payload;
			}
		);
		builder.addMatcher(
			pipedriveApi.endpoints.getPipedriveCompanySyncTrigger.matchFulfilled,
			(state, { payload }) => {
				state.companySyncTrigger = payload;
			}
		);
		builder.addMatcher(
			pipedriveApi.endpoints.updatePipedriveCompanySyncTrigger.matchFulfilled,
			(state, { payload }) => {
				state.companySyncTrigger = payload;
			}
		);
		builder.addMatcher(
			pipedriveApi.endpoints.getPipedriveCompanyDealCreationTrigger.matchFulfilled,
			(state, { payload }) => {
				state.dealCreationTrigger = payload;
			}
		);
		builder.addMatcher(
			pipedriveApi.endpoints.updatePipedriveCompanyDealCreationTrigger.matchFulfilled,
			(state, { payload }) => {
				state.dealCreationTrigger = payload;
			}
		);
		builder.addMatcher(
			pipedriveApi.endpoints.getPipedriveDealConfig.matchFulfilled,
			(state, { payload }) => {
				state.dealConfig = payload;
			}
		);
		builder.addMatcher(
			pipedriveApi.endpoints.savePipedriveDealConfig.matchFulfilled,
			(state, { payload }) => {
				state.dealConfig = payload;
			}
		);
		builder.addMatcher(
			pipedriveApi.endpoints.getPipedriveLeadConfig.matchFulfilled,
			(state, { payload }) => {
				state.leadConfig = payload;
			}
		);
		builder.addMatcher(
			pipedriveApi.endpoints.savePipedriveLeadConfig.matchFulfilled,
			(state, { payload }) => {
				state.leadConfig = payload;
			}
		);
		builder.addMatcher(pipedriveApi.endpoints.disconnectPipedriveOAuth.matchFulfilled, (state) => {
			state.oauthStatus = { connected: false };
		});
	},
});

export const pipedriveReducer = pipedriveSlice.reducer;
export const pipedriveSelector = (state: RootState) => state[pipedriveSlice.name];
